import type { PlatformType } from "@/shared/contexts/Platform";
import { ProductCurrencyType } from "@/types/graphql/site.generated";

// Единственное место, где вычисляется «оба обязательных url платформы
// заданы» — и PaymentTerms.tsx (рендерить блок условий или нет), и
// ProductPayment.tsx (блокировать ли кнопку оплаты галочкой, Task 11)
// читают именно эту функцию, а не повторяют условие текстуально. Так им
// физически нечем разойтись, если у платформы появится третье обязательное
// поле или одно из существующих переименуют.
export function getPaymentTermsUrls(
  platform: PlatformType | null | undefined,
): { termsOfServiceUrl: string; refundPolicyUrl: string } | null {
  const termsOfServiceUrl = platform?.termsOfServiceUrl;
  const refundPolicyUrl = platform?.refundPolicyUrl;

  if (!termsOfServiceUrl || !refundPolicyUrl) return null;

  return { termsOfServiceUrl, refundPolicyUrl };
}

// Галочка «принимаю условия и политику возврата» нужна только Paynet
// (требование его интеграционного пакета), а Paynet на бэкенде обслуживает
// единственную валюту MDL (ProviderAvailabilityService.CURRENCIES_BY_PROVIDER).
// Поэтому «продукт продаётся через молдавскую платёжку» на витрине
// однозначно читается по валюте выбранной цены. Stripe/CCBill принимают
// оплату без явного согласия, там чекбокс только мешает.
export function isPaymentTermsRequired(
  platform: PlatformType | null | undefined,
  currency: ProductCurrencyType | string | null | undefined,
): boolean {
  return (
    currency === ProductCurrencyType.MdlType && !!getPaymentTermsUrls(platform)
  );
}
